module.exports = __webpack_public_path__ + "static/media/Teachable Machine（自定义训练语音分类器）.184013c2.png";